import { render, staticRenderFns } from "./HoverPopover.vue?vue&type=template&id=5dd57c56&"
import script from "./HoverPopover.vue?vue&type=script&lang=js&"
export * from "./HoverPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports